module.exports = __webpack_public_path__ + "img/icon-vehicle-type-n2.07eef09f.svg";